import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Divider, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Plans from "../components/Plans";
import UserHeader from "../components/Header/UserHeader";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

import { Token } from "../atom/atom";
import { useRecoilValue } from "recoil";
import CreateStyleButton from "../components/Dashboard/CreateStyleDialog";
import { Box } from "@mui/material";
import Delete from "@mui/icons-material/Delete";

export default function Dashboard(props) {
  const isAuthenticated = useRecoilValue(Token);
  const subtitleStyles = {
    marginBottom: "1rem",
  };
  const navigate = useNavigate();
  const TrashLink = (props) => <Link to="/trash" {...props} />;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/home");
    } else {
      navigate("/scenarios");
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <UserHeader {...props} />
      <Container
        maxWidth="xl"
        sx={{
          paddingTop: "2rem",
          marginBottom: "4rem",
          justifyContent: "flex-start",
          textAlign: "left",
        }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={7}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pb: 3,
              }}
            >
              <Typography
                variant="h1"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem", md: "2rem" } }}
              >
                Your analyses
              </Typography>
              <CreateStyleButton />
            </Box>
            <Plans settings={props} />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Typography variant="h6" sx={subtitleStyles}>
              Tools & resources
            </Typography>
            <Stack spacing={2}>
              <Typography variant="body1">More to come.</Typography>
              <Divider />
              <Box
                display="flex"
                alignContent="center"
                component={TrashLink}
                sx={{ textDecoration: "none", "&:hover": { opacity: 0.8 } }}
              >
                <Delete color="primary" sx={{ mr: 1 }} />
                <Typography color="primary">Trash</Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </Box>
  );
}
